import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const ACCENTS = {
    blue: { fg: '#1890ff', bg: '#e6f4ff' },
    green: { fg: '#16a34a', bg: '#e7f8ee' },
    amber: { fg: '#d97706', bg: '#fef3c7' },
    violet: { fg: '#7c3aed', bg: '#ede9fe' },
    slate: { fg: '#475569', bg: '#eef2f7' },
};

// Compact KPI tile: small uppercase label, large value, optional suffix/hint and
// a soft-tinted icon chip. Matches the --wsb card language.
const StatTile = ({ label, value, suffix, hint, icon, accent = 'blue' }) => {
    const a = ACCENTS[accent] || ACCENTS.blue;
    return (
        <div
            style={{
                background: 'var(--wsb-surface)',
                border: '1px solid var(--wsb-border)',
                borderRadius: 18,
                boxShadow: 'var(--wsb-shadow)',
                padding: '18px 20px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Text
                    style={{
                        textTransform: 'uppercase',
                        letterSpacing: 0.6,
                        fontSize: 11,
                        fontWeight: 600,
                        color: 'var(--wsb-muted)',
                    }}
                >
                    {label}
                </Text>
                {icon && (
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 34,
                            height: 34,
                            borderRadius: 12,
                            background: a.bg,
                            color: a.fg,
                        }}
                    >
                        {icon}
                    </span>
                )}
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                <span style={{ fontSize: 30, fontWeight: 700, color: 'var(--wsb-text)', lineHeight: 1.15 }}>
                    {value}
                </span>
                {suffix && (
                    <span style={{ fontSize: 14, color: 'var(--wsb-muted)', fontWeight: 500 }}>{suffix}</span>
                )}
            </div>
            {hint && <Text style={{ fontSize: 12.5, color: 'var(--wsb-muted)' }}>{hint}</Text>}
        </div>
    );
};

export default StatTile;
